import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_URL, {
            withCredentials: true,
            transports: ['websocket'],
            //autoConnect: true,
            query:{
                username: "Saeed",
                isMobile: false,
                //isMobile: navigator.userAgentData.mobile,
                //isMobile: navigator.userAgentData?.mobile ?? /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
                //browser: navigator.userAgent
                browser: getBrowserName() + " . Version:" + getBrowserVersion()
            }
        });

        function getBrowserName() {
            if (typeof navigator === "undefined") return "unknown";

            const ua = navigator.userAgent;

            if (/Edg/i.test(ua)) return "Edge";
            if (/OPR|Opera/i.test(ua)) return "Opera";
            if (/Chrome/i.test(ua) && !/Edg|OPR/i.test(ua)) return "Chrome";
            if (/Safari/i.test(ua) && !/Chrome|CriOS|Edg/i.test(ua)) return "Safari";
            if (/Firefox/i.test(ua)) return "Firefox";

            return "unknown";
        }

        function getBrowserVersion() {
            //if (typeof navigator === "undefined") return "unknown Version";

            const ua = navigator.userAgent;

            let match =
                ua.match(/(edg|edge)\/(\d+)/i) ||
                ua.match(/(chrome)\/(\d+)/i) ||
                ua.match(/(firefox)\/(\d+)/i) ||
                ua.match(/version\/(\d+).*(safari)/i);

            if (!match) return "Unknown Version";

            return parseInt(match[2], 10);
        }

export default socket;